import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {async } from 'angular-async-await';
declare var paypal;

@Component({
  selector: 'app-capracticante',
  templateUrl: './capracticante.component.html',
  styleUrls: ['./capracticante.component.css']
})
export class CapracticanteComponent implements OnInit {

  @ViewChild ('paypal', { static : true }) paypalElement: ElementRef;

  product = {
    price:381.00,
    description: 'Conexión Akashico (Practicante)',
    moneda: 'USD'
    
  };
 
  paidFor = false;
   

  ngOnInit() {
    paypal
    .Buttons({
      createOrder: (data, actions) => {
        return actions.order.create({
            purchase_units:[
              {
              description: this.product.description,
              amount:{
                flow: 'checkout',
                currency: this.product.moneda,
                value: this.product.price,
                
              }
            }
          ]
        });
      },
      onApprove: async (data, actions) => {
        const order = await actions.order.capture();
        this.paidFor = true;
        console.log (order);
      },
      onError: err => {
        console.log(err);
      }
    })
    .render(this.paypalElement.nativeElement);
    
  }

}
